import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"

const api = new APIClient();

// Get All
export const getContact = (params?: any) => api.get(url.GET_CONTACT, params);
export const getCount = () => api.get(url.GET_COUNT, {});
// Search by Keyword
export const searchByKeyword = (params?: any) => api.get(url.SEARCH_BY_KEYWORD, params);
// Add
export const addContact = (payload: any) => api.create(url.ADD_CONTACT, payload)
// Bulk Import
export const bulkImportContacts = (payload: any[]) => api.create(url.BULK_IMPORT_CONTACTS, payload)

// Get Detail
export const getDetail = (id: string) => api.get(`${url.GET_DETAIL_CONTACT}/${id}`, {})

// Get Detail
export const updateContact = (id: string, payload: any) => api.put(`${url.GET_DETAIL_CONTACT}/${id}`, payload)

// Get Detail
export const deleteContact = (id: string) => api.delete(`${url.GET_DETAIL_CONTACT}/${id}`, {})
export const getSaleRepOptions = () => api.get(url.GET_SALE_REP, {})
export const getAllList =  () : any => api.get(url.GET_ALL_LIST, {})